export default __webpack_public_path__ + "static/media/features.93b7c0f8.png";